import { useState } from 'react'
import { fg } from '../copyFeatGrowth'
import { recordPlus, type PlusSurface } from '../lib/plus'
import { Check } from '../ui/icons'
import { buttonClass } from '../ui/styles'

/**
 * The Plus offer (features 10/16): what Plus would include, at $10 a month, with "I'd join" and "Not now". Records intent
 * only (lib/plus.ts): no payment fields, no charge, no sign-up. The caller decides when it shows (flag plus_offer).
 */
export function PlusOffer({ surface, onDone }: { surface: PlusSurface; onDone?: () => void }) {
  const [answer, setAnswer] = useState<null | 'join' | 'not_now'>(null)
  const pick = (choice: 'join' | 'not_now') => {
    if (answer) return
    recordPlus(choice, surface)
    setAnswer(choice)
    onDone?.()
  }
  return (
    <section data-review-id={`plus-offer-${surface}`} aria-labelledby={`plus-title-${surface}`} className="mt-5 border border-line bg-surface p-5">
      <p className="t-label text-ink-2">{fg('fg.plus_kicker')}</p>
      <h2 id={`plus-title-${surface}`} className="t-headline mt-1 text-ink">{fg('fg.plus_title')}</h2>
      <p className="t-body mt-2 text-ink-2">{fg('fg.plus_body')}</p>
      <ul className="mt-3 space-y-1.5">
        {(['fg.plus_item_1', 'fg.plus_item_2', 'fg.plus_item_3'] as const).map((k) => (
          <li key={k} className="t-body flex items-start gap-2 text-ink"><Check size={18} className="mt-0.5 shrink-0 text-accent" />{fg(k)}</li>
        ))}
      </ul>
      {answer ? (
        <p role="status" data-review-id="plus-thanks" className="t-body mt-4 border-l-[3px] border-accent pl-3 text-ink">
          {fg(answer === 'join' ? 'fg.plus_thanks_join' : 'fg.plus_thanks_no')}
        </p>
      ) : (
        <>
          <div className="mt-4 grid grid-cols-2 gap-2">
            <button type="button" data-review-id="plus-join" onClick={() => pick('join')} className={buttonClass('primary', 'md', 'w-full')}>{fg('fg.plus_join')}</button>
            <button type="button" data-review-id="plus-not-now" onClick={() => pick('not_now')} className={buttonClass('secondary', 'md', 'w-full')}>{fg('fg.plus_not_now')}</button>
          </div>
          <p className="t-meta mt-2 text-ink-2">{fg('fg.plus_note')}</p>
        </>
      )}
    </section>
  )
}
